export default __webpack_public_path__ + "static/media/Abiogenesis_LE.b5915adb.jpg";